import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M64.5832 1H1.00317C1.00317 1 0.833209 5.45998 2.98321 11.73C4.83321 17.13 12.3232 28.24 28.7432 27.09H36.1732C52.5932 28.25 61.2332 16.57 62.7632 11.07C64.4132 5.13001 64.5832 1 64.5832 1Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
